import { put, takeLatest, select, call } from "redux-saga/effects";
import {
  ORDER_PLACE_DETAIL,
  ORDER_PLACE_DETAIL_RECEIVED,
  EMPTY_ORDER_PLACE_DETAIL,
  CART_DETAIL_STATUS_CHANGED,
  EMPTY_CART_DETAIL,
  LOADING_STATUS,
  GET_ORDER_HISTORY_DETAIL,
  ORDER_HISTORY_DETAIL_RECEIVED,
  EMPTY_ORDER_HISTORY_DETAIL,
  DELETE_RECENT_AND_CART_ORDER,
  EMPTY_VOUCHER_LIST_DETAIL,
  GET_VOUCHER_LIST_DETAIL,
  VOUCHER_LIST_DETAIL_RECEIVED,
  EMPTY_RECENT_ORDER_ID,
  RECENT_ORDER_ID_RECEIVED,
  GET_APPLY_VOUCHER_DETAIL,
  APPLY_VOUCHER_DETAIL_RECEIVED,
  EMPTY_APPLY_VOUCHER_DETAIL,
  AVOCADO_MEMBER_LIST_RECEIVED,
  ADD_DETAIL_CARD_TOKEN,
  EMPTY_REORDER_ORDER_IDS,
  REORDER_ORDER_IDS_RECEIVED,
  POS_SOCKET_ORDER_RECIEVE,
  CHECK_QUANTITY_FAILED,
  CHECK_QUANTITY_SUCCEEDED,
  CHECK_QUANTITY_REQUESTED,
  CHANGE_ORDER_TIP,
  CART_DETAIL_RECEIVED,
  REMOVE_COMBINED_ORDER,
  QUANTITY_CHECK_CART_ITEMS_DETAIL,
} from "../actions/types";
import {
  showNotificationWithTimeout,
  changeOrderSocketEmit,
  changeTipDetail,
  changeStatusCartDetail,
  changePosCartDetail,
  emptyPosCartDetail,
  toggleShowCompletePage,
  changeSessionExpiredPage,
  changePaymentDetail,
  checkOpenOrder,
  sendPaymentMail,
  item86DetailRecieved,
  temproryPosData,
} from "../actions";
import {
  avocadoAuthToken,
  checkArray,
  checkNull,
  deepCopy,
  getAllMenuIds,
  getCartSubmittedItems,
  getDeviceId,
  getPosCartSubmittedItems,
  getReOrderItemIds,
  getSessionStorageOrDefault,
  orderHistoryApi,
  parseRound,
} from "../../helpers";
import moment from "moment";

const defaultErrorMsg = "Something went wrong! try again later.";
const base_url = process?.env?.REACT_APP_API_URL;

// Advocado API
const ad_api_url = process?.env?.REACT_APP_AVOCADO_API_URL;
const ad_username = process?.env?.REACT_APP_AVOCADO_API_USERNAME;
const ad_password = process?.env?.REACT_APP_AVOCADO_API_PASSWORD;

let myHeaders = {
  "Content-Type": "application/json",
  Accept: "application/json",
  // "Access-Control-Allow-Origin": "*",
};

function* quantityCheckedDetails(action) {
  yield put({ type: LOADING_STATUS, status: true });
  const cartItems = yield select(
    (store) => store?.cartDetailReducer?.cart_detail
  );
  const table_detail = yield select(
    (store) => store?.tableDetailReducer?.table_detail
  );
  const menuIds = getAllMenuIds(cartItems?.filter((p) => p?.is_added == false));
  const payload = {
    merchant_id: table_detail?.Merchant?.id,
    date: moment().format("yyyy-MM-DD"),
    menu_item_ids: menuIds,
  };

  const json = yield fetch(`${base_url}/qr_code_apis/get_menuitem_quotas`, {
    method: "POST",
    mode: "cors",
    headers: new Headers(myHeaders),
    body: JSON.stringify(payload),
  })
    .then((response) => response.json())
    .then((json) => json)
    .catch((error) => console.log("orderPlace failed : " + error.message));
  if (json.status) {
    // console.log("quantityCheckedDetails", json);
    // yield put({
    //   type: actionTypes.CHECK_QUANTITY_SUCCEEDED,
    // });
    const quotaItems = json?.data ?? [];
    console.log(
      "quotaItemsquotaItemsquotaItems------------------->>>>>>>>>>>>",
      quotaItems
    );
    ;
    yield put({type: QUANTITY_CHECK_CART_ITEMS_DETAIL,payload:quotaItems});
    if (
      checkArray(quotaItems) &&
      quotaItems.findIndex((p) => p?.is_86_item == "yes" || p?.quota !== "") >
        -1
    ) {
      let errorMsg = "";
      let isErrorShown = false;
      cartItems.map((item) => {
        const prefix = errorMsg !== "" ? " " : "";

        // Standard
        const checkExistIdx = quotaItems.findIndex((p) => {
          console.log(
            "checkExistIdx1111",
            item.id == p?.menu_item_id,
            p?.is_86_item == "yes",
            p?.quota !== "" && parseInt(p?.quota) < item.quantity
          );
          return (
            item.id == p?.menu_item_id &&
            (p?.is_86_item == "yes" ||
              (p?.quota !== "" && parseInt(p?.quota) < item.quantity))
          );
        });
        console.log("checkExistIdx", checkExistIdx);
        if (checkExistIdx > -1) {
          isErrorShown = true;
          const checkQuotaItem = quotaItems[checkExistIdx];
          if (checkQuotaItem?.is_86_item == "yes") {
            errorMsg = errorMsg + prefix + `${item?.pos_name},`;
            // `"${item?.pos_name}" is no longer available for order.`;
          } else if (
            checkQuotaItem?.quota !== "" &&
            parseInt(checkQuotaItem?.quota) < item.quantity
          ) {
            errorMsg =
              errorMsg +
              prefix +
              `Only "${parseInt(
                checkQuotaItem?.quota
              )}" units are available to order for "${
                item?.pos_name
              }" at the moment.`;
          }
        }
        // Bundled Components
        const checkComExistIdx = quotaItems.findIndex(
          (p) =>
            item?.BundledMenuItem &&
            checkArray(item?.BundledMenuItem) &&
            item?.BundledMenuItem.findIndex(
              (bunItem) =>
                bunItem.bundle_menu_item_id == p?.menu_item_id &&
                (p?.is_86_item == "yes" ||
                  (p?.quota !== "" && parseInt(p?.quota) < bunItem.quantity))
            ) > -1
        );
        if (!isErrorShown && checkComExistIdx > -1) {
          isErrorShown = true;
          const checkQuotaItem = quotaItems[checkComExistIdx];
          const bunItemIdx = item?.BundledMenuItem.findIndex(
            (bunItem) =>
              bunItem.bundle_menu_item_id == checkQuotaItem?.menu_item_id &&
              (checkQuotaItem?.is_86_item == "yes" ||
                (checkQuotaItem?.quota !== "" &&
                  parseInt(checkQuotaItem?.quota) < bunItem.quantity))
          );
          if (bunItemIdx > -1) {
            item?.BundledMenuItem?.map((bunItemObj) => {
              if (
                bunItemObj.bundle_menu_item_id == checkQuotaItem?.menu_item_id
              ) {
                if (checkQuotaItem?.is_86_item == "yes") {
                  errorMsg =
                    errorMsg +
                    prefix +
                    `"${bunItemObj?.bundle_menu_item_name}" of ${item?.pos_name} is no longer available for order.`;
                } else if (
                  checkQuotaItem?.quota !== "" &&
                  parseInt(checkQuotaItem?.quota) < bunItemObj.quantity
                ) {
                  errorMsg =
                    errorMsg +
                    prefix +
                    `Only "${parseInt(
                      checkQuotaItem?.quota
                    )}" units are available to order for "${
                      bunItemObj?.bundle_menu_item_name
                    }" of ${item?.pos_name} at the moment.`;
                }
              }
            });
          }
        }
      });

      if (isErrorShown) {
        yield put({
          type: CHECK_QUANTITY_FAILED,
          payload: {
            showError: true,
            errorMsg:  errorMsg,
          },
        });
      } else {
        yield put({
          type: CHECK_QUANTITY_SUCCEEDED,
        });
      }
    } else {
      yield put({
        type: CHECK_QUANTITY_SUCCEEDED,
      });
    }
  } else {
    yield put(
      showNotificationWithTimeout(
        `${json?.message ? json.message : defaultErrorMsg}`,
        "error"
      )
    );
    yield put({
      type: CHECK_QUANTITY_FAILED,
      payload: { error: json.message },
    });
  }
  yield put({ type: LOADING_STATUS, status: false });
}

function* checkSubmitActiveOrder(action) {
  console.log(
    "base_url=============================== checkSubmitActiveOrder",
    base_url
  );
  const cart_detail = yield select(
    (state) => state?.cartDetailReducer?.cart_detail
  );
  const recent_order_id = yield select(
    (state) => state?.cartDetailReducer?.recent_order_id
  );

  const is_payment_started = yield select(
    (state) => state?.paymentDetailReducer?.is_payment_started
  );
  const is_payment_cleared = yield select(
    (state) => state?.paymentDetailReducer?.is_payment_cleared
  );
  yield put({ type: LOADING_STATUS, status: true });
  // yield put({ type: EMPTY_RECENT_ORDER_ID });
  console.log(" commented EMPTY_RECENT_ORDER_ID");
  let items = cart_detail.filter((p) => p.is_added == false);
  console.log("checking the cart data items %%%%%%%%%%%%%%%%%%%%%%%%%%%%%",items)
  const token = yield select(
    (state) => state?.authDetailReducer?.user_detail?.token
  );
  const server_order_id = yield select(
    (state) => state?.tableDetailReducer?.server_order_id
  );
  const deviceId = yield getDeviceId();
  const servicePeriodExpire = getSessionStorageOrDefault(
    "servicePeriodExpire",
    undefined
  );
  myHeaders.token = token;
  const orderPayload = {
    customer_id: action.customerId ?? "",
    merchant_id: action.merchantId ?? "",
    table_number: action.tableNumber ?? "",
    date: servicePeriodExpire ?? "",
  };
  if (checkNull(server_order_id, false)) {
    delete orderPayload.customer_id;
    orderPayload.order_id = server_order_id;
  }
  const json = yield fetch(`${base_url}/qr_code_apis/get_order_details`, {
    method: "POST",
    mode: "cors",
    headers: new Headers(myHeaders),
    body: JSON.stringify(orderPayload),
  })
    .then((response) => response.json())
    .then((json) => json)
    .catch((error) =>
      console.log("checkActiveOrder failed : " + error.message)
    );

  if (json?.status) {
    if (json?.data?.open_orders !== null) {
      const orders = json?.data?.open_orders;
      const table_detail = yield select(
        (state) => state?.tableDetailReducer?.table_detail
      );
      if (checkNull(recent_order_id, false)) {
        console.log("orderiddddd:", recent_order_id, orders?.order_offline_id);
        if (
          checkNull(orders?.order_offline_id, false) === false ||
          (orders?.order_offline_id &&
            recent_order_id != orders?.order_offline_id &&
            !is_payment_cleared)
        ) {
          console.log("Sessionnnn Expiredddd");
          // yield put(changeSessionExpiredPage(true));
        }
      }

      console.log(
        orders[0]?.order_offline_id,
        "orders=========================="
      );
      yield put({
        type: RECENT_ORDER_ID_RECEIVED,
        payload: orders[0]?.order_offline_id ?? "",
      });
      yield put({
        type: CHANGE_ORDER_TIP,
        payload: orders?.tips ?? 0,
      });
      console.log("ordersssss===>", orders);
      // const orderItems = getCartSubmittedItems(orders[0], table_detail);
      const orderItems = getCartSubmittedItems(orders, table_detail);

      console.log("ordersssss===>orderItems", orderItems);
      for (let i = 0; i < orderItems.length; i++) {
        if (orderItems[i].hasOwnProperty("is_server_fired")) {
          orderItems[i].is_added =
            orderItems[i].is_server_fired == "yes" || orderItems[i].is_fired
              ? true
              : false;
        } else {
          orderItems[i].is_added = true;
        }
      }
      // debugger;
      if (orderItems?.length > 0) {
        // items = [...items, ...orderItems];
        let filterItems = orderItems.filter(
          (ele, ind) =>
            ind ===
            orderItems.findIndex(
              (elem) => elem.offline_id === ele.offline_id && elem.id === ele.id
            )
        );

        items = [...filterItems];
      }
      // const posItems = getPosCartSubmittedItems(orders[0], table_detail); // TODO payment_type
      const posItems = getPosCartSubmittedItems(orders, table_detail); // TODO payment_type

      if (posItems?.length > 0) {
        yield put(
          changePosCartDetail({
            payment_type: orders[0]?.payment_type ?? [],
            split_type_name: orders[0]?.split_type_name ?? "",
            promotions: orders[0]?.promotions ?? [],
            items: posItems,
            transaction_id: orders[0]?.transaction_id ?? [],
            fiserv_order_id: orders[0]?.fiservorderId ?? [],
          })
        );
        yield put(
          changePaymentDetail({
            paymentOpenOrders: json?.data?.open_orders,
            paymentType: checkArray(orders[0]?.payment_type) ? "split" : "",
            splitPaymentArr: orders[0]?.payment_type ?? [],
            wayToSplit: checkArray(orders[0]?.payment_type)
              ? orders[0]?.payment_type.length
              : 2,
            splitType: checkNull(orders[0]?.split_type_name, false)
              ? orders[0]?.split_type_name == "Split Evenly"
                ? 1
                : orders[0]?.split_type_name == "Split By Item"
                ? 2
                : 3
              : 0,
          })
        );
      } else {
        yield put(emptyPosCartDetail());
      }
    }
    yield put(
      item86DetailRecieved(
        json?.data?.["86_items"] && checkArray(json?.data?.["86_items"])
          ? json?.data?.["86_items"]
          : []
      )
    );
    // if (checkArray(json?.data?.["86_items"])) {
    //   const items_86 = json?.data?.["86_items"];
    //   yield put(item86DetailRecieved(items_86));
    //   // check already 86 items
    //   const items86Ids = pluckArray(items_86, "id");
    //   const already86ItemsName = [];
    //   const already86ItemsId = [];
    //   cart_detail
    //     .filter((p) => p.is_added == false)
    //     .map((cartItem) => {
    //       if (items86Ids.includes(cartItem.id)) {
    //         already86ItemsId.push(cartItem.id);
    //         already86ItemsName.push(cartItem.pos_name);
    //       }
    //     });
    //   if (checkArray(already86ItemsName)) {
    //     yield put(
    //       showItemAvailableModal(
    //         `${already86ItemsName.join(", ")} ${
    //           already86ItemsName.length > 1 ? "are" : "is"
    //         } no longer available, removed from your basket.`
    //       )
    //     );
    //   }
    //   if (checkArray(already86ItemsId)) {
    //     items = items.filter(
    //       (p) => p.is_added == true || !already86ItemsId.includes(p.id)
    //     );
    //   }
    //   // check already 86 items END
    // }
  } else {
    yield put(
      showNotificationWithTimeout(
        `${json?.message ? json.message : defaultErrorMsg}`,
        "error"
      )
    );
    console.log(
      `checkActiveOrder error : ${
        json?.message ? json.message : defaultErrorMsg
      }`
    );
  }
  console.log(" ----------- CART_DETAIL_RECEIVED ------------------", items);
  yield put({ type: CART_DETAIL_RECEIVED, cart_detail: items });
  yield put({ type: LOADING_STATUS, status: false });
  return json;
}

function* orderPlace(action) {
  console.log("base_url", base_url);

  const payloadBody = action?.body;
  console.log(
    "recent order updated ------------------------>>>>>>>>>>>>>>1",
    payloadBody
  );
  yield put({ type: EMPTY_ORDER_PLACE_DETAIL });
  // yield put({ type: EMPTY_RECENT_ORDER_ID });
  console.log("commented Recent EMPTY_RECENT_ORDER_ID");
  yield put({ type: LOADING_STATUS, status: true });
  const token = yield select(
    (state) => state?.authDetailReducer?.user_detail?.token
  );
  const como_details = yield select(
    (state) => state?.authDetailReducer?.como_details
  );
  const user_detail = yield select(
    (state) => state?.authDetailReducer?.user_detail
  );
  const server_user_detail = yield select(
    (state) => state?.authDetailReducer?.server_user_detail
  );
  const is_payment_started = yield select(
    (state) => state?.paymentDetailReducer?.is_payment_started
  );
  const paymentBody = yield select(
    (state) => state?.paymentDetailReducer?.paymentBody
  );
  const mail_order_detail = yield select(
    (state) => state?.paymentDetailReducer?.mail_order_detail
  );
  const cartPreItems = yield select(
    (store) => store?.cartDetailReducer?.cart_detail
  );

  myHeaders.token = token;
  console.log("myHeaders", myHeaders);

  const userId = checkNull(user_detail?.id, false)
    ? user_detail?.id
    : paymentBody?.qr_customer_id ?? null;

  if (is_payment_started && payloadBody?.order_status === "complete") {
    yield put(
      changePaymentDetail({
        is_payment_cleared: true,
      })
    );
  }

  if (server_user_detail?.id) {
    payloadBody.employee_id = server_user_detail?.id;
  }
  payloadBody.order_type = server_user_detail?.id ? "server" : "qr";

  if (como_details?.membership) {
    payloadBody.loyaltyToken = como_details?.membership?.comoMemberId;
    payloadBody.loyaltyCardNumber = checkNull(
      como_details?.membership?.phoneNumber,
      como_details?.membership?.email
    );
    payloadBody.loyalty_login_type = checkNull(
      como_details?.membership?.phoneNumber,
      false
    )
      ? "mobile"
      : "email";
  }


  myHeaders.token = yield select(
    (state) => state?.authDetailReducer?.authToken
  );
  // const serverorder = yield select(
  //   (state) => state?.tableDetailReducer?.qr_order
  // );
  // myHeaders.serverorder = serverorder?"yes":"no"
// myHeaders.serverorder ="yes"

 myHeaders.deviceid =  yield getDeviceId();


  const json = yield fetch(`${base_url}/qr_code_apis/submitOrder`, {
    method: "POST",
    mode: "cors",
    headers: new Headers(myHeaders),
    body: JSON.stringify(payloadBody),
  })
    .then((response) => response.json())
    .then((json) => json)
    .catch((error) => console.log("orderPlace failed : " + error.message));
  if (json?.status && json?.data) {
    const orderId = json?.data?.["order_list"]?.[0]?.order_offline_id ?? "";
    const cartItems = json?.data?.["order_list"]?.[0]?.menu_item ?? [];
    console.log(cartItems, "cartItemscartItemscartItemscartItems");
    for (let i = 0; i < cartPreItems.length; i++) {
      if (cartPreItems[i].hasOwnProperty("is_fired")) {
        cartPreItems[i].is_added = true;
      }
      if (cartPreItems[i].hasOwnProperty("is_server_fired")) {
        cartPreItems[i].is_server_fired = "yes";
      }
    }

    console.log("cartPreItems ------------------------ ", cartPreItems);
    console.log("cartItems ---------------------------- ", cartItems);
    // yield put({ type: EMPTY_CART_DETAIL });
    yield put(changeStatusCartDetail(cartPreItems));
    yield put(changePosCartDetail(cartPreItems));
    yield put(temproryPosData(cartItems));

    // yield put(changeStatusCartDetail(cartItems))
    // yield put(changePosCartDetail(cartItems))
    // console.log("cartPreItems ------------------------ ",cartPreItems)
    // console.log("cartItems ---------------------------- ",cartItems)

    // if (action.onlyTip !== true) {
    //   yield put({ type: CART_DETAIL_STATUS_CHANGED });
    // }
    yield put(changeTipDetail(payloadBody?.tips ?? 0));
    yield put({ type: ORDER_PLACE_DETAIL_RECEIVED, payload: json?.data });
    yield put({
      type: RECENT_ORDER_ID_RECEIVED,
      payload: orderId,
    });
    // send Payment Mail
    if (checkNull(mail_order_detail, false) && checkNull(orderId, false)) {
      const copyOrderDetail = deepCopy(mail_order_detail);
      copyOrderDetail.billId = orderId;
      yield put(sendPaymentMail({ order_detail: copyOrderDetail }));
    }
    // send Payment Mail END

    yield put(changeOrderSocketEmit(true));
    if (!is_payment_started && action?.hideToast === false) {
      if (action.onlyTip === true) {
        yield put(
          showNotificationWithTimeout(
            `Tip has been updated to the order successfully`,
            "success"
          )
        );
      } else {
        yield put(
          showNotificationWithTimeout(
            `${json?.message ? json.message : "success"}`,
            "success"
          )
        );
      }
    }
  } else {
    if (is_payment_started && payloadBody?.order_status === "complete") {
      yield put(
        changePaymentDetail({
          is_payment_cleared: false,
        })
      );
    }
    else{
    yield put(changeSessionExpiredPage(true));

    }
    // yield put(
    //   showNotificationWithTimeout(
    //     `${json?.message ? json.message : defaultErrorMsg}`,
    //     "error"
    //   )
    // );
    console.log(
      `orderPlace error : ${json?.message ? json.message : defaultErrorMsg}`
    );
  }
  yield put({
    type: CHECK_QUANTITY_FAILED,
    payload: { error: json.message },
  });
  if (payloadBody?.order_status !== "complete" && userId && json?.status ) {
    const submitCheck = yield call(checkSubmitActiveOrder, {
      merchantId: payloadBody?.merchant_id ?? "",
      tableNumber: payloadBody?.table_no ?? "",
      customerId: userId,
    });
    console.log(
      "isStartedddd11111",
      moment().format("yyyy-mm-dd HH:mm:ss"),
      submitCheck
    );
  }
  yield put({ type: LOADING_STATUS, status: false });
}

function* remove_order(action) {

  myHeaders.token = yield select(
    (state) => state?.authDetailReducer?.authToken
  );
// const serverorder = yield select(
//   (state) => state?.tableDetailReducer?.qr_order
// );
// myHeaders.serverorder = serverorder?"yes":"no"
// myHeaders.serverorder ="yes"
 myHeaders.deviceid =  yield getDeviceId();


  const json = yield fetch(`${base_url}/qr_code_apis/submitOrder`, {
    method: "POST",
    mode: "cors",
    headers: new Headers(myHeaders),
    body: JSON.stringify(action?.payload),
  })
    .then((response) => response.json())
    .then((json) => json)
    .catch((error) => console.log("orderPlace failed : " + error.message));

  yield put({ type: LOADING_STATUS, status: false });
}

function* orderHistory(action) {
  console.log("base_url", base_url);
  console.log("action.bodyyyyyy orderHistory", action);
  yield put({ type: EMPTY_REORDER_ORDER_IDS });
  yield put({ type: EMPTY_ORDER_HISTORY_DETAIL });
  yield put({ type: EMPTY_VOUCHER_LIST_DETAIL });
  yield put({ type: LOADING_STATUS, status: true });
  const token = yield select(
    (state) => state?.authDetailReducer?.user_detail?.token
  );
  const customerId = yield select(
    (state) => state?.authDetailReducer?.user_detail?.id
  );
  const user_detail = yield select(
    (state) => state?.authDetailReducer?.user_detail
  );
  const avocadoDetail = yield select(
    (state) => state?.authDetailReducer?.avocado_detail
  );
  const deviceId = yield getDeviceId();
  const orderHistoryData = yield orderHistoryApi({
    deviceId: deviceId,
    token: token,
    merchantId: action?.merchantId ?? "",
    customerId: customerId ?? "",
  });
  if (orderHistoryData?.status && orderHistoryData?.data) {
    yield put({
      type: ORDER_HISTORY_DETAIL_RECEIVED,
      payload: orderHistoryData?.data,
    });
    const reOrderIds = getReOrderItemIds(orderHistoryData?.data);
    if (reOrderIds.length > 0) {
      yield put({ type: REORDER_ORDER_IDS_RECEIVED, payload: reOrderIds });
    }
  } else {
    yield put(
      showNotificationWithTimeout(
        `${
          orderHistoryData?.message ? orderHistoryData.message : defaultErrorMsg
        }`,
        "error"
      )
    );
    console.log(
      `ORDER_HISTORY error : ${
        orderHistoryData?.message ? orderHistoryData.message : defaultErrorMsg
      }`
    );
  }
  if (avocadoDetail !== null) {
    const authToken = yield avocadoAuthToken();
    console.log("authTokenDetail:", authToken);
    if (authToken?.access_token?.value) {
      myHeaders.Authorization = "Bearer " + authToken?.access_token?.value;
      const memberShipList = yield fetch(`${ad_api_url}/v1.1/memberships`, {
        mode: "cors",
        headers: new Headers(myHeaders),
      })
        .then((response) => response.json())
        .then((json) => json)
        .catch((error) =>
          console.log("avocado_membership_list failed : " + error.message)
        );
      if (
        memberShipList?.code == 200 &&
        memberShipList?.data?.tiers &&
        memberShipList?.data?.tiers.length > 0
      ) {
        yield put({
          type: AVOCADO_MEMBER_LIST_RECEIVED,
          payload: memberShipList?.data?.tiers,
        });
      }
    }
  }
  if (user_detail?.CardNo) {
    myHeaders.token = token;
    const voucherList = yield fetch(`${base_url}/ascentis/get_vouchers`, {
      method: "POST",
      mode: "cors",
      headers: new Headers(myHeaders),
      body: JSON.stringify({
        CardNo: user_detail?.CardNo,
        merchant_id: action?.merchantId ?? "",
      }),
    })
      .then((response) => response.json())
      .then((json) => json)
      .catch((error) => console.log("VOUCHER_LIST failed : " + error.message));
    if (voucherList?.status && voucherList?.data) {
      // yield put({ type: EMPTY_CART_DETAIL });
      yield put({
        type: VOUCHER_LIST_DETAIL_RECEIVED,
        payload: voucherList?.data,
      });
    } else {
      yield put(
        showNotificationWithTimeout(
          `${voucherList?.message ? voucherList.message : defaultErrorMsg}`,
          "error"
        )
      );
      console.log(
        `VOUCHER_LIST error : ${
          voucherList?.message ? voucherList.message : defaultErrorMsg
        }`
      );
    }
  }

  yield put({ type: LOADING_STATUS, status: false });
}

function* redeemVoucher(action) {
  console.log("base_url", base_url);
  console.log("action.body redeemVoucher", action?.voucher);
  // yield put({ type: EMPTY_APPLY_VOUCHER_DETAIL });
  yield put({ type: LOADING_STATUS, status: true });
  const token = yield select(
    (state) => state?.authDetailReducer?.user_detail?.token
  );
  const user_detail = yield select(
    (state) => state?.authDetailReducer?.user_detail
  );
  const cart_detail = yield select(
    (state) => state?.cartDetailReducer?.cart_detail
  );
  const applied_voucher = yield select(
    (state) => state?.cartDetailReducer?.applied_voucher
  );

  const TransactDetailLists =
    cart_detail?.length > 0
      ? cart_detail?.map((item) => {
          return {
            Category_Code: item?.sub_category_id ?? "",
            ItemCode: item?.id ?? "",
            Description: item?.name ?? "",
            Qty: item?.quantity ?? "",
            Price: item?.menu_item_price ?? 0,
            Points: null,
            DiscountPer: 0,
            Nett: item?.total ?? 0,
            LineNo: 1,
          };
        })
      : [];

  // myHeaders.token = token;
  console.log("myHeaders", myHeaders);

  if (user_detail?.CardNo) {
    const getVoucherType = yield fetch(
      `${base_url}/ascentis/get_voucher_type`,
      {
        method: "POST",
        mode: "cors",
        headers: new Headers(myHeaders),
        body: JSON.stringify({
          CardNo: user_detail?.CardNo,
          voucherTypeCode: action?.voucher?.VoucherTypeCode,
          merchant_id: action?.merchantId ?? "",
        }),
      }
    )
      .then((response) => response.json())
      .then((json) => json)
      .catch((error) => console.log("APPLY_VOUCHER failed : " + error.message));
    if (getVoucherType?.data?.access_token) {
      let cardAccToken = getVoucherType?.data?.access_token;
      yield put({
        type: ADD_DETAIL_CARD_TOKEN,
        payload: cardAccToken.replace("Bearer ", ""),
      });
    }
    if (
      getVoucherType?.status &&
      getVoucherType?.data?.VoucherTypeLists &&
      getVoucherType?.data?.VoucherTypeLists.length > 0
    ) {
      const voucherListArr = getVoucherType?.data?.VoucherTypeLists.map(
        (voucherItem) => {
          voucherItem.VoucherNo = action?.voucher?.VoucherNo;
          return voucherItem;
        }
      );
      yield put({
        type: APPLY_VOUCHER_DETAIL_RECEIVED,
        payload:
          applied_voucher.length > 0
            ? [...applied_voucher, ...voucherListArr]
            : voucherListArr,
      });
      const voucherTypeValue = parseFloat(
        getVoucherType?.data?.VoucherTypeLists?.[0].TypeValue ?? 0
      );
      /* NOT IN USE */
      // const PointsRedemption = {
      //   DollarToPointsRatio: "1:10:10:10",
      //   PointsToBeDeducted: voucherTypeValue,
      //   PointsUsage: 2,
      //   GivenRebateValue: 3,
      //   PointsToBeDeductedFromGrace: 0,
      // };
      // const applyVoucherList = yield fetch(`${base_url}/ascentis/sales`, {
      //   method: "POST",
      //   mode: "cors",
      //   headers: new Headers(myHeaders),
      //   body: JSON.stringify({
      //     CardNo: user_detail?.CardNo,
      //     VoucherNo: action?.voucher?.VoucherNo,
      //     TransactDetailLists: TransactDetailLists,
      //     PointsRedemption: PointsRedemption,
      //   }),
      // })
      //   .then((response) => response.json())
      //   .then((json) => json)
      //   .catch((error) =>
      //     console.log("APPLY_VOUCHER failed : " + error.message)
      //   );
      // if (applyVoucherList?.status && applyVoucherList?.data) {
      //   // yield put({ type: EMPTY_CART_DETAIL });
      //   yield put({
      //     type: APPLY_VOUCHER_DETAIL_RECEIVED,
      //     payload: action?.voucher,
      //   });
      // } else {
      //   yield put(
      //     showNotificationWithTimeout(
      //       `${
      //         applyVoucherList?.message
      //           ? applyVoucherList.message
      //           : defaultErrorMsg
      //       }`,
      //       "error"
      //     )
      //   );
      //   console.log(
      //     `APPLY_VOUCHER error : ${
      //       applyVoucherList?.message
      //         ? applyVoucherList.message
      //         : defaultErrorMsg
      //     }`
      //   );
      // }
    } else {
      yield put(
        showNotificationWithTimeout(
          `${
            getVoucherType?.message ? getVoucherType.message : defaultErrorMsg
          }`,
          "error"
        )
      );
      console.log(
        `APPLY_VOUCHER error : ${
          getVoucherType?.message ? getVoucherType.message : defaultErrorMsg
        }`
      );
    }
  }

  yield put({ type: LOADING_STATUS, status: false });
}

function* deletRecentAndCartOrder(action) {
  yield put({ type: LOADING_STATUS, status: true });
  yield put({ type: EMPTY_CART_DETAIL });
  yield put({ type: EMPTY_ORDER_PLACE_DETAIL });
  yield put({ type: EMPTY_RECENT_ORDER_ID });
  yield put({ type: LOADING_STATUS, status: false });
}
function* posOrderRecieveDetail(action) {
  const table_detail = yield select(
    (state) => state?.tableDetailReducer?.table_detail
  );
  const is_payment_started = yield select(
    (state) => state?.paymentDetailReducer?.is_payment_started
  );
  const paymentBody = yield select(
    (state) => state?.paymentDetailReducer?.paymentBody
  );
  yield put({ type: LOADING_STATUS, status: true });
  console.log("order_socket_pos_order", action.pos_order);
  yield put(changeTipDetail(action.pos_order?.tips ?? 0));
  const items = getCartSubmittedItems(action.pos_order, table_detail);
  console.log("ordersssss===>items", items);
  let showUpdatedWarning = false;
  // debugger;
  if (items?.length > 0) {
    yield put(changeStatusCartDetail(items));
  }
  const posItems = getPosCartSubmittedItems(action.pos_order, table_detail);
  if (is_payment_started) {
    if (
      (checkArray(paymentBody?.menu_item) &&
        checkArray(posItems?.length) &&
        posItems?.length !== paymentBody?.menu_item?.length) ||
      parseRound(paymentBody?.finalTotalAmt) !==
        parseRound(action?.pos_order?.finalTotalAmt) ||
      paymentBody?.tips !== action?.pos_order?.tips
    ) {
      showUpdatedWarning = true;
    }
  }

  if (posItems?.length > 0) {
    yield put(
      changePosCartDetail({
        payment_type: action.pos_order?.payment_type ?? [],
        split_type_name: action.pos_order?.split_type_name ?? "",
        promotions: action.pos_order?.promotions ?? [],
        items: posItems,
        transaction_id: action.pos_order?.transaction_id ?? [],
        fiserv_order_id: action.pos_order?.fiservorderId ?? [],
      })
    );
    yield put(
      changePaymentDetail({
        paymentType: checkArray(action.pos_order?.payment_type) ? "split" : "",
        splitPaymentArr: action.pos_order?.payment_type ?? [],
        wayToSplit: checkArray(action.pos_order?.payment_type)
          ? action.pos_order?.payment_type.length
          : 2,
        splitType: checkNull(action.pos_order?.split_type_name, false)
          ? action.pos_order?.split_type_name == "Split Evenly"
            ? 1
            : action.pos_order?.split_type_name == "Split By Item"
            ? 2
            : 3
          : 0,
      })
    );
  } else {
    yield put(emptyPosCartDetail());
  }
  if (action.pos_order?.order_status == "complete") {
    yield put(toggleShowCompletePage(true));
  } else if (
    (action.pos_order?.table_no !==
      table_detail?.PosTableMaster?.table_number &&
      !is_payment_started) ||
    action.pos_order?.order_status == "cancelled"
  ) {
    console.log("ordersssss===>Session Expireddd");
    // yield put(changeSessionExpiredPage(true));
  } else if (showUpdatedWarning) {
    yield put(
      showNotificationWithTimeout(
        `Warning! order has been updated through POS`,
        "error"
      )
    );
  }
  yield put({ type: LOADING_STATUS, status: false });
}

export default function* cartDetailActionWatcher() {
  yield takeLatest(ORDER_PLACE_DETAIL, orderPlace);
  yield takeLatest(GET_ORDER_HISTORY_DETAIL, orderHistory);
  yield takeLatest(GET_APPLY_VOUCHER_DETAIL, redeemVoucher);
  yield takeLatest(DELETE_RECENT_AND_CART_ORDER, deletRecentAndCartOrder);
  yield takeLatest(POS_SOCKET_ORDER_RECIEVE, posOrderRecieveDetail);
  yield takeLatest(CHECK_QUANTITY_REQUESTED, quantityCheckedDetails);
  yield takeLatest(REMOVE_COMBINED_ORDER, remove_order);
}
